/**
 * Страница отчетов
 * ***/

const $reportsWrap = $('.js-reports-downloads-wrap');
const $reportsFilter = $('.js-reports-downloads-filter');

const $downloadReportsFilterSelect = $('.js-download-reports-filter-select');

if ($downloadReportsFilterSelect.length) {
    $downloadReportsFilterSelect.on('change', function () {
        const $currFilterWrap = $(this).closest('.js-download-reports-filter-item');
        const currValue = $(this).find(':selected').val();

        $currFilterWrap.find('.js-download-reports-file-item').removeClass('_visible')
            .filter(`[data-file="${currValue}"]`).addClass('_visible');
    });
}

if ($reportsWrap.length) {
    const $moreReportsBtn = $('.js-more-reports-downloads-btn');
    const $pageInput = $('.js-page-input');

    $moreReportsBtn.on('click', function (e) {
        let currentPage = parseInt($pageInput.val());

        $pageInput.val(currentPage + 1);
        loadReportsDownload();

        e.preventDefault();
    });

    App.D.on('click', '.js-toggle-files', function (e) {
        const $currToggleItem = $(this);

        $currToggleItem.toggleClass('_showen');
        $currToggleItem.parent()
            .siblings('.reports-item__files').stop().slideToggle();

        e.preventDefault();
    });
}

/***
 * @addContent — флаг показываем добавлять контент в блок или заменить контент в блоке новым
 * */
function loadReportsDownload(withSort) {
    let $reportsItems = $('.js-reports-items');

    App.H.addClass('_loading');

    $.ajax({
        url: $reportsFilter.attr('action'),
        data: $reportsFilter.serialize(),
        type: $reportsFilter.attr('method') || 'GET',
        cache: false,
        success: (response) => {
            if ($(response).find('.js-reports-wrap').length) {
                const $newReports = $(response).find('.js-reports-item');

                if (withSort) {
                    $reportsWrap.html('');
                }

                const $lastYearItem = $('.js-reports-title').last();
                let lastYear = $lastYearItem.html();

                $newReports.each(function () {
                    const $currReportItem = $(this);
                    const currYear = $currReportItem.data('year').toString();
                    let currReportHtml = `<div class="reports-item js-reports-item">${$currReportItem.html()}</div>`;

                    if (currYear === lastYear) {
                        $reportsItems.last().append(currReportHtml);
                    } else {
                        lastYear = currYear;

                        $reportsWrap.append(`<div class="reports-title js-reports-title title-h3">${currYear}</div>`);
                        $reportsWrap.append(`<div class="reports-items js-reports-items">${currReportHtml}</div>`);

                        $reportsItems = $('.js-reports-items');
                    }
                });

                App.H.removeClass('_loading');
            } else {
                console.log('Ошибка получения данных');
            }

            App.H.removeClass('_loading');
        },
        error: () => {
            console.log('Ошибка загрузки отчетов');
            App.H.removeClass('_loading');
        }
    });
}


// WEBPACK FOOTER //
// ./_src/js/ReportsDownloadsPage.js